import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { CLICKABLE_COLOR } from '@CSSVars/colors'

export const _ClusterContent = styled.div`
  width: 30px;
  height: 30px;
  border: 2px solid white;
  background-color: ${CLICKABLE_COLOR};
  border-radius: 50%;
  //transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    color: white;
    margin-bottom: 1px;
  }
  &:hover {
    cursor: pointer;
  }

`
